import {mount} from "@manaakiwhenua/landcover-explorer/dist/landcover-explorer.js";
import "@manaakiwhenua/landcover-explorer/dist/landcover-explorer.css";

/**
 * The Silverstripe Requirements_Backend renders all javascript <script src="" /> tags first, then
 * if renders the custom <script>...</script> tags.
 *
 * This means that the landcover-explorer.js file is rendered before landcover-explorer.config.js
 */
function initLandCoverExplorer() {
    const config = window.landcoverExplorerConfig ?? {};
    console.log('Initializing landcover explorer with config: ', config)

    const props = {
        tilePrefix: config.tilePrefix || undefined,
        basemap: config.baseMapURL
            ? {
                url: config.baseMapURL,
                attribution: config.baseMapAttribution ? [config.baseMapAttribution] : undefined
            }
            : undefined
    };

    for (const target of document.querySelectorAll('.landcover-explorer')) {
        mount({target, props});
    }
}

window.addEventListener('load', initLandCoverExplorer);
